import React from "react";
import { Collapse } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import SidebarNavList from "./SidebarNavList.js";

const SidebarNavSection = (props) => {
  const { title, icon, pages, collapsible = false, defaultOpen = false } = props;
  const { pathname } = useLocation();
  const hasActivePage = React.useMemo(() => {
    const matchesCurrentPath = (items = []) => items.some((item) => {
      const matchesHref = item.href
        && (pathname === item.href || pathname.startsWith(`${item.href}/`));

      return matchesHref || matchesCurrentPath(item.children);
    });

    return matchesCurrentPath(pages);
  }, [pages, pathname]);
  const [open, setOpen] = React.useState(defaultOpen || hasActivePage);

  React.useEffect(() => {
    if (hasActivePage) setOpen(true);
  }, [hasActivePage, pathname]);

  return (
    <React.Fragment>
      {title && (
        <li
          className={`sidebar-header${collapsible ? " cursor-pointer" : ""}`}
          onClick={collapsible ? () => setOpen((current) => !current) : undefined}
          aria-expanded={collapsible ? open : undefined}
          role={collapsible ? "button" : undefined}
          tabIndex={collapsible ? 0 : undefined}
          onKeyDown={collapsible ? (event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              setOpen((current) => !current);
            }
          } : undefined}
        >
          {icon && <FontAwesomeIcon icon={icon} className="me-2" />}
          {title}
          {collapsible && (
            <FontAwesomeIcon
              icon={open ? faChevronUp : faChevronDown}
              className="float-end mt-1"
              aria-hidden="true"
            />
          )}
        </li>
      )}
      {collapsible ? (
        <Collapse in={open}>
          <div>
            <SidebarNavList pages={pages} depth={0} />
          </div>
        </Collapse>
      ) : (
        <SidebarNavList pages={pages} depth={0} />
      )}
    </React.Fragment>
  );
};

export default SidebarNavSection;
